import axios from "./axios";
import { ADMIN_API_ROOT } from "./api-root";

export const CommonServer = {
    Mine: {
        /**
         * 更新当前登录管理员信息
         */
        modify: (params: any) => {
            return axios.post(
                `${ADMIN_API_ROOT}/index/upinfo`,
                params
            );
        },
        /**
         * 刷新邀请码
         */
        refresh: (params?: any) => {
            return axios.get(
                `${ADMIN_API_ROOT}/index/refreshInviteCode`,
                { params }
            );
        },
        /**
         * 当前管理员绑定谷歌验证器(获取二维码与密钥)
         */
        bindGoogleAuth: (params?: any) => {
            return axios.get(
                `${ADMIN_API_ROOT}/index/bind-google-auth`,
                { params }
            );
        },
        /**
         * 谷歌验证器绑定后提交验证
         */
        submitGoogleAuth: (params: any) => {
            return axios.post(
                `${ADMIN_API_ROOT}/index/google-authenticator-submit`,
                params
            );
        },
        /**
         * 重置当前管理员谷歌验证器
         */
        resetGoogleAuth: (params: any) => {
            return axios.post(
                `${ADMIN_API_ROOT}/index/reset-google-auth`,
                params
            );
        },
    },
    Home: {
        /**
         * 统计
        */
        statistic: (params: any) => {
            return axios.get(
                `${ADMIN_API_ROOT}/statistic/index`,
                { params }
            );
        },
        /**
        * 提醒
       */
        remind: (params: any) => {
            return axios.get(
                `${ADMIN_API_ROOT}/statistic/remind`,
                { params }
            );
        }
    },
    Level: {
        /**
         * 等级列表
         */
        list: (params: any) => {
            return axios.get(
                `${ADMIN_API_ROOT}/card-category/list`,
                { params }
            );
        },
        entityList: (params: any) => {
            return axios.get(
                `${ADMIN_API_ROOT}/card-category/physical-select-list`,
                { params }
            );
        },
        /**
         * 等级添加
         */
        create: (params: any) => {
            return axios.post(`${ADMIN_API_ROOT}/card-category/add`, params);
        },
        /**
         * 等级更新
         */
        modify: (params: any) => {
            return axios.post(
                `${ADMIN_API_ROOT}/card-category/update`,
                params
            );
        },
        /**
         * 修改状态
        */
        enabled: async (params: any) => {
            return axios.post(
                `${ADMIN_API_ROOT}/grade/update`,
                { ...params, Status: params.Status ? 1 : 2 }
            );
        },
    },
    Common: {
        uploadFile: async (params: any) => {
            return axios.post(
                `${ADMIN_API_ROOT}/common/upload`,
                params,
            );
        }
    }
}